module.exports = __webpack_public_path__ + "media/images/extension-onboarding/arrow-middle-42eae80dfe16c3f62f392ca3fe32d155.png";